import sanitizeParams from "./sanitizeParams";

const formatParams = (params, filterGroups = [], sanitize) => {
	const paramsCopy = new URLSearchParams(params.toString());
	const filterGroupKeys = filterGroups.map(group => group.slug);
	const filterKeys = ['sort', 'q', 'lang', 'pageNumber', ...filterGroupKeys]
	const keysToFilter = sanitize ? filterKeys : null;

	return sanitizeParams(keysToFilter, paramsCopy);
}

export default formatParams;
